module.exports = __webpack_public_path__ + "static/media/J4o.881563d6.gif";